import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Leaf } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-cream" data-testid="auth-loading">
        <Leaf className="w-8 h-8 text-clay animate-pulse" />
        <p className="mt-4 text-sm text-forest/60 tracking-[0.2em] uppercase">Cargando tu ritual…</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/acceder" replace />;
  return children;
}
